/* Homepage entrance controller. No analytics parameters or navigation targets are rewritten. */
(() => {
  if (customElements.get('cl-entry-gate')) return;
  class CLEntryGate extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.events = { signal: this.abort.signal };
      this.key = 'cl-entry-2026:' + this.dataset.theme;
      this.video = this.querySelector('video');
      this.motion = this.querySelector('[data-motion]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.editor = Boolean(window.Shopify && Shopify.designMode);
      const home = this.querySelector('[data-enter-home]');
      if (home) { const url = new URL(location.href); url.hash = 'cl-home'; url.searchParams.delete('entry'); home.href = url.pathname + url.search + url.hash; }
      this.on = false;
      this.userPaused = false;
      this.addEventListener('click', (event) => this.click(event), this.events);
      this.addEventListener('toggle', (event) => this.toggle(event), { ...this.events, capture: true });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeMenus();
      }, this.events);
      window.addEventListener('hashchange', () => this.sync(), this.events);
      window.addEventListener('pageshow', () => this.sync(), this.events);
      document.addEventListener('visibilitychange', () => this.playback(), this.events);
      this.reduced.addEventListener('change', () => this.playback(), this.events);
      this.mobile.addEventListener('change', () => this.playback(), this.events);
      if (this.video) this.video.addEventListener('playing', () => this.video.classList.add('is-playing'), this.events);
      document.addEventListener('shopify:section:select', (event) => {
        if (this.editor) this.setOpen(event.detail.sectionId === this.dataset.section);
      }, this.events);
      document.addEventListener('shopify:block:select', (event) => {
        if (this.editor && this.contains(event.target)) this.setOpen(true);
      }, this.events);
      this.sync();
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      document.documentElement.classList.remove('cl-entry-active');
      this.restoreApp();
    }
    remember() { try { sessionStorage.setItem(this.key, '1'); } catch (_) {} }
    entered() { try { return sessionStorage.getItem(this.key) === '1'; } catch (_) { return false; } }
    sync() {
      const p = new URLSearchParams(location.search);
      const bypass = location.hash === '#cl-home' || p.get('entry') === '0';
      const force = p.get('entry') === '1';
      this.setOpen(!bypass && (force || this.editor || this.dataset.once !== 'true' || !this.entered()));
    }
    restoreApp() {
      const app = document.getElementById('app');
      if (!app || !this.savedApp) return;
      if (this.savedApp.aria === null) app.removeAttribute('aria-hidden');
      else app.setAttribute('aria-hidden', this.savedApp.aria);
      app.inert = this.savedApp.inert;
      this.savedApp = null;
    }
    setOpen(open) {
      this.on = open;
      document.documentElement.classList.toggle('cl-entry-active', open);
      this.setAttribute('aria-hidden', open ? 'false' : 'true');
      this.inert = !open;
      const app = document.getElementById('app');
      if (open && app && !this.savedApp) {
        this.savedApp = { aria: app.getAttribute('aria-hidden'), inert: app.inert };
        app.setAttribute('aria-hidden', 'true'); app.inert = true;
      } else if (!open) this.restoreApp();
      this.playback();
    }
    playback() {
      if (!this.video) return;
      const reduced = this.reduced.matches || Boolean(navigator.connection && navigator.connection.saveData);
      const allowed = this.on && !document.hidden && !reduced && !this.userPaused;
      if (this.motion) this.motion.hidden = reduced || !this.on;
      if (!allowed) { this.video.pause(); if (reduced) this.video.classList.remove('is-playing'); return; }
      const source = (this.mobile.matches ? this.video.dataset.mobileSrc : this.video.dataset.desktopSrc) || this.video.dataset.desktopSrc;
      if (!source) return;
      if (this.video.getAttribute('src') !== source) {
        this.video.classList.remove('is-playing');
        this.video.src = source; this.video.load();
      }
      this.video.muted = true; this.video.defaultMuted = true;
      const play = this.video.play();
      if (play && play.catch) play.catch(() => this.video.classList.remove('is-playing'));
    }
    closeMenus(except) {
      this.querySelectorAll('details[open]').forEach((details) => { if (details !== except) details.open = false; });
    }
    toggle(event) {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      const summary = details.querySelector('summary');
      const id = summary && summary.getAttribute('aria-controls');
      const panel = id && document.getElementById(id);
      if (panel) panel.hidden = !details.open;
      if (summary) summary.setAttribute('aria-expanded', String(details.open));
      if (details.open) this.closeMenus(details);
    }
    click(event) {
      const motion = event.target.closest('[data-motion]');
      if (motion) {
        this.userPaused = !this.userPaused;
        motion.setAttribute('aria-label', this.userPaused ? 'Play background video' : 'Pause background video');
        motion.setAttribute('aria-pressed', String(this.userPaused));
        this.playback(); return;
      }
      const link = event.target.closest('a');
      if (!link || !this.contains(link)) return;
      if (link.hasAttribute('data-enter-home') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault(); this.remember();
        const url = new URL(location.href); url.hash = 'cl-home';
        url.searchParams.delete('entry');
        history.replaceState(history.state, '', url.pathname + url.search + url.hash);
        this.setOpen(false);
        const main = document.getElementById('mainContent');
        if (main) { main.setAttribute('tabindex', '-1'); main.focus({preventScroll:true}); }
        window.scrollTo(0,0);
      } else { this.remember(); }
    }
  }
  customElements.define('cl-entry-gate', CLEntryGate);
})();
